var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3588 2H7.6412C4.25586 2 2 4.4199 2 7.89317V16.1068C2 19.5833 4.24992 22 7.6412 22H16.3588C19.7501 22 22 19.5833 22 16.1068V7.89317C22 4.41665 19.7501 2 16.3588 2ZM7.64124 3.39527H16.3588C18.9563 3.39527 20.6047 5.16579 20.6047 7.89309V16.1068C20.6047 18.834 18.9563 20.6046 16.3588 20.6046H7.64124C5.04376 20.6046 3.39539 18.834 3.39539 16.1068V7.89309C3.39539 5.16941 5.04927 3.39527 7.64124 3.39527ZM12.7268 7.17881C12.6806 6.83828 12.3887 6.57581 12.0355 6.57581C11.6502 6.57581 11.3378 6.88817 11.3378 7.27348V16.7086L11.3442 16.8032C11.3904 17.1438 11.6823 17.4062 12.0355 17.4062C12.4208 17.4062 12.7332 17.0939 12.7332 16.7086V7.27348L12.7268 7.17881ZM8.38571 10.2323C8.33951 9.89178 8.04761 9.62931 7.6944 9.62931C7.30909 9.62931 6.99673 9.94167 6.99673 10.327V16.7085L7.0031 16.8032C7.04929 17.1437 7.3412 17.4062 7.6944 17.4062C8.07972 17.4062 8.39207 17.0938 8.39207 16.7085V10.327L8.38571 10.2323ZM16.3057 13.0016C16.6589 13.0016 16.9508 13.264 16.997 13.6046L17.0034 13.6993V16.7086C17.0034 17.0939 16.691 17.4062 16.3057 17.4062C15.9525 17.4062 15.6606 17.1438 15.6144 16.8032L15.608 16.7086V13.6993C15.608 13.3139 15.9204 13.0016 16.3057 13.0016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLines);
export default __webpack_public_path__ + "static/media/Chart-lines.0bf1e58f.svg";
export { ForwardRef as ReactComponent };